// import { getMessaging } from "firebase/messaging";
// import { firebaseApp } from "./firebase-config";

// export const messaging = getMessaging(firebaseApp);

// USE THIS WHEN NOT HTTPS OR LOCALHOST
import { firebaseApp } from './firebase-config';
import { getMessaging, Messaging } from 'firebase/messaging';

let messaging: Messaging | null = null;

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(firebaseApp);
  } catch (error) {
    console.error("Firebase Messaging error:", error);
  }
}

export { messaging };